import { AttackPattern, PatternState } from '../AttackPattern.js';

/** Records its own earlier volleys and replays them as a ghost layer. */
export class Palimpsest extends AttackPattern {
  constructor({ minPhase = 0, config }) {
    super({ name: 'Palimpsest', telegraphDuration: 0.9, activeDuration: 4.2, minPhase });
    this.config = config;
    this._history = [];
  }

  onBegin() { this._timer = 0; this._fired = 0; this._replay = []; }

  onActiveTick(dt, boss, player, pool) {
    this._timer -= dt;
    if (this._timer > 0) return;
    this._timer = this.config.interval;
    const count = this.config.count + boss.phase * 2;
    const volley = [];
    const aim = Math.atan2(player.y - boss.y, player.x - boss.x);
    for (let i = 0; i < count; i++) {
      const angle = aim + (i - (count - 1) / 2) * this.config.spread;
      volley.push({ angle, speed: this.config.speed, damage: this.config.damage });
      pool.fire({ x: boss.x, y: boss.y, vx: Math.cos(angle) * this.config.speed, vy: Math.sin(angle) * this.config.speed, radius: 2.5, damage: this.config.damage, color: '#d58cff', lifetime: 4 });
    }
    this._history.push(volley);
    if (this._history.length > 3) this._history.shift();
    if (this._history.length > 1) {
      const replay = this._history[0];
      for (const shot of replay) {
        pool.fire({ x: boss.x, y: boss.y, vx: Math.cos(shot.angle) * shot.speed * 0.86, vy: Math.sin(shot.angle) * shot.speed * 0.86, radius: 2.5, damage: shot.damage, color: '#8c7bff', lifetime: 4 });
      }
    }
    this._fired++;
  }

  getVisual(boss) {
    if (this.state !== PatternState.TELEGRAPH) return null;
    return { kind: 'ringPulse', x: boss.x, y: boss.y, t: 1 - this._timer / this.telegraphDuration };
  }
}
